import { SelectSingleChangeHandler, SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventRole } from "../types/eventType";

interface Props {
	label: string;
	name: string;
	description?: string;
	required?: boolean;
	onChange?: SelectSingleChangeHandler<EventRole>;
}

const options = Object.values(EventRole);

export const EventRoleSingleSelectField: FC<Props> = ({ label, name, required, description, onChange }) => {
	const { t } = useTranslation();
	return (
		<SingleSelectField
			label={label}
			name={name}
			getLabel={(role) => t(role)}
			clearable={false}
			options={options}
			required={required}
			description={description}
			onChange={onChange}
		/>
	);
};
